import HeaderActions from "../redux/actions/header";
import FooterActions from "../redux/actions/footer";
// import HomeActions from "../redux/actions/home";
import ExchangeHolidayActions from "@frameworks/web/redux/actions/StaticFooter/ExchangeHolidayActions";
import CircularUpdateActions from "@frameworks/web/redux/actions/StaticFooter/CircularUpadateActions";
import ScripDetailActions from "@frameworks/web/redux/actions/common/ScripDetail";
import LocateUsActions from "../redux/actions/StaticFooter/LocateUsActions";
import FaqActions from "../redux/actions/StaticFooter/FaqActions";
import LiveNewsActions from "@frameworks/web/redux/feature/LiveNews/actions/LiveNews";
import InvestorActions from "../redux/actions/Home/investor";
import WebinarActions from "../redux/actions/Home/webinar";
import AdBlockActions from "../redux/actions/Home/adBlock";
import MarketNewsActions from "../redux/actions/Home/marketNews";
import NewOnEdelActions from "../redux/actions/Home/newOnEdel";
import AllOfferingsActions from "../redux/actions/Home/allOfferings";
export default () => {
    return {
        header: new HeaderActions(),
        // home: new HomeActions(),
        home: {
            investor: new InvestorActions(),
            webinar: new WebinarActions(),
            adBlock: new AdBlockActions(),
            marketNews: new MarketNewsActions(),
            newOnEdel: new NewOnEdelActions(),
            offerings: new AllOfferingsActions(),
        },
        footer: {
            footer: new FooterActions(),
            staticFooter: {
                exchangeHolidays: new ExchangeHolidayActions(),
                circularUpdate: new CircularUpdateActions(),
                location: new LocateUsActions(),
                faq: new FaqActions(),
            },
        },
        common: {
            scripDetailActions: new ScripDetailActions(),
        },
        liveNews: new LiveNewsActions(),
    };
};
